import { render, staticRenderFns } from "./Clubs.vue?vue&type=template&id=3a89b8e9"
import script from "./Clubs.vue?vue&type=script&lang=js"
export * from "./Clubs.vue?vue&type=script&lang=js"
import style0 from "./Clubs.vue?vue&type=style&index=0&id=3a89b8e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports